<template>
  <div class="register">
    <ui-title :title="t('buttons.createAcc')" :wave="'/authTitleBg.png'" />
    <div class="container">
      <div class="register__wrapper">
        <register-form />
        <img class="register__wave" src="@images/authWave.png" alt="wave">
      </div>
    </div>
  </div>
</template>

<script setup>
import {useI18n} from "vue-i18n";
import UiTitle from "@/components/ui/ui-title.vue";
import RegisterForm from "@/components/forms/register-form.vue";

const {t} = useI18n()
</script>

<style lang="scss" scoped>
.register {
  top: -103px;
  background-color: $white;
  position: relative;

  &__wrapper {
    padding-block: 50px 100px;
  }

  &__wave {
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
</style>